import { Api } from './Api';

const  ENPOINTS = {
    CodePromo: 'code-promos',
};

const getAll = signal => {
    return Api.get(ENPOINTS.CodePromo, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.CodePromo}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(ENPOINTS.CodePromo, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.CodePromo}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.CodePromo}/${id}`, signal)
}

export const CodePromoService = {
    getAll,
    getById,
    create,
    update,
    destroy
}